import {FC, useEffect, useState} from 'react'
import {useQuery} from 'react-query'
import {UserEditModalForm} from './UserEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getUserById} from '../core/_requests'
import axios from 'axios'

export const GET_ALL_ROLES_URL = `${process.env.REACT_APP_API_URL_BACKEND}/role`;

const UserEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: user,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-user-${itemIdForUpdate}`,
    () => {
      return getUserById(itemIdForUpdate)
              .then((data) => {
                data.d_o_b = data.profile.d_o_b;
                data.gender = data.profile.gender;
                data.social_security = data.profile.social_security;
                return data;
              });
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  
  const [roles, setRoles] = useState();

  useEffect(() => {
    getAllRoles();    
  }, []);

  const getAllRoles = async () => {
    
    try {
      const {data: result} = await axios.get(GET_ALL_ROLES_URL);
        setRoles(result.data);  
    } catch (err) {
      console.log(err)
    }     
  };


  if (!itemIdForUpdate) {
    return <UserEditModalForm isUserLoading={isLoading} user={{id: undefined}} roles={roles} />
  }

  if (!isLoading && !error && user) {
    return <UserEditModalForm isUserLoading={isLoading} user={user} roles={roles} />
  }

  return null
}

export {UserEditModalFormWrapper}
